import * as React from "react";
import Component from "../../AbstractComponent";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";

export default class ContractSummary extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
		const contract: ContractInterface = this.props.contract;
		const monthlyChargeTemplatesAmount: number = [...(contract?.chargeTemplates || [])]
      .filter((chargeTemplate: ChargeTemplateInterface) => chargeTemplate?.repeatPeriod?.id === PeriodContainer.pickIdFromLabel("monthly"))
      .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.amount)
      .reduce((a, b) => a + b, 0);
	  
		return (
			<div className="contract-summary">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{display: "flex", alignItems: "baseline"}}>
						<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
							{this.trans("label-contract")}
						</div>
						<div className="title" style={{color: contract?.getStatusColor()}}>
							{this.trans(contract?.contractStatus)}
						</div>
					</div>
					<div className="date">
						{this.formatter.formatDate(contract?.firstDate)}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">
						{`${contract?.tenantDisplayName}`}
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
						<div className="currency">
							{
								!!monthlyChargeTemplatesAmount ?
									contract?.chargeTemplates?.[0].currency?.getIso() : 
									this.props.app?.settings?.user?.currency?.getIso()
							}
						</div>
						<div className="amount">
							{
								!!monthlyChargeTemplatesAmount ?
									this.formatter.formatNumber(monthlyChargeTemplatesAmount) :
									this.formatter.formatNumber(monthlyChargeTemplatesAmount)
							}
						</div>
					</div>
				</div>
				<div>
					<table>
						<tr>
							<td className="align-left first-column">
								{`${this.trans("unit")}: `}
							</td>
							<td className="align-left">
								<div className="margin-wrapper">
									<div 
										className="link-to-entity" 
										onClick={() => this.redirect(`/app/unit/update/${contract?.unitId}/`)}
									>
										{`${contract?.unit?.displayName}`}
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		);
  }
}
